export default "__VITE_ASSET__D593xpHG__"